export const getOffset = (offset) => {
  switch (offset) {
    case "noOffset":
      return 0
    case "lowOffset":
      return 4
    case "highOffset":
      return 16
    default:
      return 8
  }
}

export const ARROW_SIZE = 20

/**
 * Checks if the arrow alignment should be modified based on the reference element's dimensions and the placement.
 * Arrow adjustment is required on placement start and end, when the reference element is smaller than the arrow size.
 * By default, the arrow is centered on the reference element. If the reference element is bigger than the arrow size, arrow should be moved to be positioned 20px from edge corner.
 * If the reference element is smaller than the arrow size, the floating element needs to be pushed by 20px (arrow size). If not, the arrow won't be positioned correctly.
 *
 * @param {number} target.width - The width of the reference element.
 * @param {number} target.height - The height of the reference element.
 * @param {string} placement - The placement of the floating element relative to the reference element.
 * @returns {boolean} - Returns true if the arrow should be displayed, otherwise false.
 */
export const shouldAdjustArrow = (target, placement) => {
  return (
    (target?.width <= ARROW_SIZE || target?.height <= ARROW_SIZE + 1) &&
    /start|end/u.test(placement)
  )
}
